'use client';
import React from 'react';
import Image from 'next/image';
import MediaPartnerSection from "@/app/mediaPartnerSection";
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Button from '@/components/ui/Button';
import Link from 'next/link';
import SpeakerSection from './SpeakerSection';
import PartnersCollaborators from './PartnersCollaborators';
import MasonryGalleryLib from './GallerySection';
import NewSpeakerSection from './NewSpeakersSection';
import AboutSection from './AboutSection';
import UpcomingEventsSection from './UpcomingEventsSection';
import HeroSection from './HeroSection';
import PastEvents from './PastEvents';
import StayConnect from './StayConnect';
import CommunitySection from './communitySection';




const HomePage: React.FC = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768, // mobile
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480, // small mobile
        settings: { slidesToShow: 1 },
      },
    ],
  };
  return (
    <div data-component-id="src/app/page.tsx:48:4" data-component-path="src/app/page.tsx" data-component-line="48" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20justify-start%20items-center%20w-full%20bg-%5B%23000000%5D%22%7D" className="flex flex-col justify-start items-center w-full bg-[#000000]">
      <Header data-component-id="src/app/page.tsx:49:6" data-component-path="src/app/page.tsx" data-component-line="49" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D"/>
      <HeroSection data-component-id="src/app/page.tsx:50:6" data-component-path="src/app/page.tsx" data-component-line="50" data-component-file="page.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" />
      <UpcomingEventsSection data-component-id="src/app/page.tsx:51:6" data-component-path="src/app/page.tsx" data-component-line="51" data-component-file="page.tsx" data-component-name="UpcomingEventsSection" data-component-content="%7B%22elementName%22%3A%22UpcomingEventsSection%22%7D" />
      {/* <NewSpeakerSection /> */}
      <PastEvents data-component-id="src/app/page.tsx:53:6" data-component-path="src/app/page.tsx" data-component-line="53" data-component-file="page.tsx" data-component-name="PastEvents" data-component-content="%7B%22elementName%22%3A%22PastEvents%22%7D" />
      <SpeakerSection data-component-id="src/app/page.tsx:54:6" data-component-path="src/app/page.tsx" data-component-line="54" data-component-file="page.tsx" data-component-name="SpeakerSection" data-component-content="%7B%22elementName%22%3A%22SpeakerSection%22%7D" />
      <MasonryGalleryLib data-component-id="src/app/page.tsx:55:6" data-component-path="src/app/page.tsx" data-component-line="55" data-component-file="page.tsx" data-component-name="MasonryGalleryLib" data-component-content="%7B%22elementName%22%3A%22MasonryGalleryLib%22%7D" />
      <AboutSection data-component-id="src/app/page.tsx:56:6" data-component-path="src/app/page.tsx" data-component-line="56" data-component-file="page.tsx" data-component-name="AboutSection" data-component-content="%7B%22elementName%22%3A%22AboutSection%22%7D" />
      <CommunitySection data-component-id="src/app/page.tsx:57:6" data-component-path="src/app/page.tsx" data-component-line="57" data-component-file="page.tsx" data-component-name="CommunitySection" data-component-content="%7B%22elementName%22%3A%22CommunitySection%22%7D" />
      <PartnersCollaborators data-component-id="src/app/page.tsx:58:6" data-component-path="src/app/page.tsx" data-component-line="58" data-component-file="page.tsx" data-component-name="PartnersCollaborators" data-component-content="%7B%22elementName%22%3A%22PartnersCollaborators%22%7D" />
      <MediaPartnerSection data-component-id="src/app/page.tsx:59:6" data-component-path="src/app/page.tsx" data-component-line="59" data-component-file="page.tsx" data-component-name="MediaPartnerSection" data-component-content="%7B%22elementName%22%3A%22MediaPartnerSection%22%7D" />
      <StayConnect data-component-id="src/app/page.tsx:60:6" data-component-path="src/app/page.tsx" data-component-line="60" data-component-file="page.tsx" data-component-name="StayConnect" data-component-content="%7B%22elementName%22%3A%22StayConnect%22%7D" />
      <Footer data-component-id="src/app/page.tsx:61:6" data-component-path="src/app/page.tsx" data-component-line="61" data-component-file="page.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </div>
  );
};
export default HomePage;